const SASS = Object.freeze({
  menuBreakpoint: {
    sm: 720,
    md: 800,
    lg: 900,
  },
  screenSize: {
    sm: 480,
    md: 670,
    lg: 1024,
    xl: 1200,
    xxl: 1600,
  },
  transitionTime: {
    fast: 150,
    base: 300,
    slow: 600,
  },
});

export default SASS;
